export type ModernizerActivityType = "assignment" | "page" | "project" | "ile";

export interface ModernizerActivityCapability {
  type: ModernizerActivityType;
  title: string;
  description: string;
}

const LMS_ACTIVITY_CAPABILITIES: ModernizerActivityCapability[] = [
  {
    type: "assignment",
    title: "Assignment",
    description: "Create an assignment with instructions, a due date, attachments, and submission settings.",
  },
  {
    type: "page",
    title: "Page",
    description:
      "Author a text or HTML lesson page — explanations, walkthroughs, or any narrative content students read inline.",
  },
  {
    type: "project",
    title: "Project",
    description:
      "Create a project brief with deliverables, assessment criteria, expected outcomes, dates, and starter files.",
  },
  {
    type: "ile",
    title: "ILE",
    description:
      "Facilitate AI-driven Socratic dialogue with Axio. Provide a description, learning objectives, and context.",
  },
];

export function getModernizerLmsActivityCapabilities(): ModernizerActivityCapability[] {
  return LMS_ACTIVITY_CAPABILITIES;
}
